module.exports = __webpack_public_path__ + "static/media/gastro-image3@3x.a1247d19.png";